import React, { createContext, useContext, useState, useEffect } from 'react';
import i18n from '../i18n/i18n';

const LanguageContext = createContext();

// اللغات المتاحة
export const LANGUAGES = {
  FR: { code: 'fr', name: 'Français', flag: '🇫🇷' },
  EN: { code: 'en', name: 'English', flag: '🇺🇸' },
  AR: { code: 'ar', name: 'العربية', flag: '🇸🇦' }
};

export const LanguageProvider = ({ children }) => {
  const [currentLanguage, setCurrentLanguage] = useState('fr');
  const [isRTL, setIsRTL] = useState(false);

  // تحميل اللغة المحفوظة عند بداية التطبيق
  useEffect(() => {
    const savedLanguage = localStorage.getItem('selectedLanguage') || 'fr';
    changeLanguage(savedLanguage);
  }, []);

  const changeLanguage = (languageCode) => {
    try {
      // تحديث i18n
      i18n.changeLanguage(languageCode);
      
      // حفظ اللغة المختارة
      localStorage.setItem('selectedLanguage', languageCode);
      
      // تحديث الحالة
      setCurrentLanguage(languageCode);
      
      // تحديد اتجاه النص
      const isRightToLeft = languageCode === 'ar';
      setIsRTL(isRightToLeft);
      
      // تحديث اتجاه الصفحة
      document.documentElement.dir = isRightToLeft ? 'rtl' : 'ltr';
      document.documentElement.lang = languageCode;
      
    } catch (error) {
      console.error('خطأ في تغيير اللغة:', error);
    }
  };

  const getCurrentLanguageInfo = () => {
    return LANGUAGES[Object.keys(LANGUAGES).find(key => 
      LANGUAGES[key].code === currentLanguage
    )] || LANGUAGES.FR;
  };

  const getAvailableLanguages = () => {
    return Object.values(LANGUAGES);
  };

  const value = {
    currentLanguage,
    isRTL,
    changeLanguage,
    getCurrentLanguageInfo,
    getAvailableLanguages,
    LANGUAGES
  };

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage يجب استخدامه داخل LanguageProvider');
  }
  return context;
};
